import { Category, Home, ManageAccounts, Receipt, Schema, Settings, SupervisorAccount, Timeline } from "@mui/icons-material";
import { CoreRoutes } from "app-constants";
import { useAuth } from "hooks";
import React from "react";

export const useSiteNavigation = () => {
    const { isAdministrator } = useAuth();
    const navigation = isAdministrator ?
        [
            {
                name: 'Home',
                link: CoreRoutes.home,
                icon: <Home />
            },
            {
                name: 'Products',
                link: CoreRoutes.products,
                icon: <Category />,
            },
            {
                name: 'Customers',
                link: CoreRoutes.customers,
                icon: <SupervisorAccount />,
            },
            {
                name: 'Sales',
                link: CoreRoutes.sales,
                icon: <Receipt />,
            },
            {
                name: 'Administration',
                link: CoreRoutes.administration,
                icon: <Settings />,
            },
            {
                name: 'Partners',
                link: CoreRoutes.partners,
                icon: <ManageAccounts />,
            },
            {
                name: 'Organization',
                link: CoreRoutes.organization,
                icon: <Schema style={{ transform: 'rotate(-90deg)' }} />,
            },
            { 
                name: 'Reporting', 
                link: CoreRoutes.reporting, 
                icon: <Timeline /> 
            },
        ] :
        [
            { 
                name: 'Home', 
                link: CoreRoutes.home, 
                icon: <Home /> 
            },
            {
                name: 'My Customers',
                link: CoreRoutes.customers,
                icon: <SupervisorAccount />,
            },
            {
                name: 'My Sales',
                link: CoreRoutes.sales,
                icon: <Receipt />,
            },
            {
                name: 'Organization',
                link: CoreRoutes.organization,
                icon: <Schema style={{ transform: 'rotate(-90deg)' }} />,
            },
            { 
                name: 'Reporting', 
                link: CoreRoutes.reporting, 
                icon: <Timeline /> 
            },
        ];


    return {
        navigation
    }
}